module.exports = __webpack_public_path__ + "img/expostyle_0824_royal_blue_pantone7687c.f738aba9.jpg";